/* eslint-disable sonarjs/cognitive-complexity */
import { BaSeLoading, BaSeParagraph, BaSeSmall1, BaSeTheme } from '@base/react';
import * as Sebrae from '@sebrae/react-core';
import React from 'react';

import { Container, ContainerIframe, ContentChat } from './chat-styled';
import { useColorsConfig } from '../../hooks/useColorsConfig';
import { useInterviewContext } from '../../context/interview-context';

export const Chat = ({ moduleId = 1 }) => {
  const { getEnv } = Sebrae.useEnv();

  const { interview } = useInterviewContext();

  const [urlChat, setUrlChat] = React.useState('');
  const [iframeLoaded, setIframeLoaded] = React.useState(false);
  const { getColorsByModule } = useColorsConfig();
  const colorSettings = React.useMemo(() => {
    return getColorsByModule(interview?.module?.id ?? moduleId);
  }, [moduleId, getColorsByModule,interview]);

  const mapEmpretecs = React.useMemo(
    () => ({
      1: {
        code: 'EMPRETEC-URBANO',
        color: colorSettings.primary.replace('#', ''),
      },
      2: {
        code: 'EMPRETEC-STARTUP',
        color: colorSettings.primary.replace('#', ''),
      },
      3: {
        code: 'EMPRETEC-ARENA',
        color: colorSettings.primary.replace('#', ''),
      },
    }),
    [colorSettings.primary],
  );

  React.useEffect(() => {
    getEnv('chatbotUrl')
      .then((response) => {
        setUrlChat(response);
      })
      .catch(console.error);
  }, [getEnv]);

  const defaultSrc = React.useMemo(() => {
    if (!urlChat) return '';

    const selectedEmpretec = mapEmpretecs[ interview?.module.id ?? moduleId];
    return `${urlChat}/embed/chat?welcomeMessage=Olá! Seja bem-vindo(a) ao processo seletivo do Empretec. Após começar fique a vontade para tirar dúvidas sobre o processo seletivo.&hiddenChatIconsService=true&startMessage=Olá&startButton=Começar&onlyMessageChannelId=true&hiddenShowOptions=true&chatIsFilterDate=false&chatIsInputMessage=true&channelId=${selectedEmpretec.code}&hiddenHomePage=true&chatIsHomePage=false&chatForegroundColor=%23ffffff&chatSendButtonColor=%23${selectedEmpretec.color}&chatShowOptionsButtonColor=%23${selectedEmpretec.color}&chatIncomingBalloonBackgroundColor=%23${selectedEmpretec.color}&chatBackgroundColor=%23ffffff`;
  }, [urlChat, mapEmpretecs, moduleId,interview]);

  // const defaultSrc = `${urlChat}/embed/chat?welcomeMessage=Olá! Seja bem-vindo(a) ao processo seletivo do Empretec. Após começar fique a vontade para tirar dúvidas sobre o processo seletivo.&hiddenChatIconsService=true&startMessage=Olá&startButton=Começar&onlyMessageChannelId=true&hiddenShowOptions=true&chatIsFilterDate=false&chatIsInputMessage=true&channelId=${mapEmpretecs[moduleIdSelected].code}&hiddenHomePage=true&chatIsHomePage=false&chatForegroundColor=%23ffffff&chatSendButtonColor=%23${mapEmpretecs[moduleIdSelected].color}&chatShowOptionsButtonColor=%23${mapEmpretecs[moduleIdSelected].color}&chatIncomingBalloonBackgroundColor=%23${mapEmpretecs[moduleIdSelected].color}&chatBackgroundColor=%23ffffff`;

  const handleIframeLoad = () => {
    setIframeLoaded(true);
  };

  const contentChatColor = React.useMemo(
    () => `#${mapEmpretecs[moduleId].color}`,
    [mapEmpretecs, moduleId],
  );

  return (
    <Container>
      <ContentChat color={contentChatColor}>
        <div>
          <svg
            width="37"
            height="38"
            viewBox="0 0 37 38"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0_29030_8909)">
              <path
                d="M18.7144 10.7268C15.1835 10.7268 12.4566 13.0592 11.627 16.5213H25.8028C24.9731 13.0592 22.2453 10.7268 18.7153 10.7268"
                fill="white"
              />
              <path
                d="M12.3218 30.7399C9.2861 28.4973 6.87339 25.2186 6.17879 21.4797H0C1.1154 30.7871 8.97464 38.0001 18.5097 38.0001C25.4272 38.0001 31.4618 34.201 34.6812 28.564C33.5235 29.5677 32.2611 30.4483 30.905 31.1631C25.1084 34.2307 17.794 34.8094 12.3208 30.7399"
                fill="white"
              />
              <path
                d="M18.7148 6.17593C25.4788 6.17593 30.5799 11.6019 30.5799 18.7963V21.0722H11.0457C12.3421 25.637 17.0168 29.0083 21.812 28.7667C26.1321 28.5704 29.7254 26.8778 32.5268 24.2083C36.7348 20.1981 37.5837 13.713 34.493 8.77778C31.1909 3.50278 25.3594 0 18.7148 0C9.17874 0 1.3195 7.21389 0.204102 16.5204H6.86158C7.81343 10.488 12.6848 6.175 18.7138 6.175"
                fill="white"
              />
            </g>
            <defs>
              <clipPath id="clip0_29030_8909">
                <rect width="36.3478" height="38" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </div>

        <div>
          <BaSeParagraph isBold color={BaSeTheme.colors.defaultColors.white}>
            Empretec
          </BaSeParagraph>
          <BaSeSmall1 isItalic color={BaSeTheme.colors.defaultColors.white}>
            Chat automático
          </BaSeSmall1>
        </div>
      </ContentChat>
      {!iframeLoaded && (
        <BaSeLoading
          backgroundColor="transparent"
          description=""
          roundedCorner={true}
          lightMode="default"
          shadowLevel={0}
          spinnerColor=""
          spinnerSize={24}
          text="Carregando chat…"
          textColor=""
        />
      )}
      <ContainerIframe>
        {defaultSrc && (
          <iframe
            title="Gerenciamento de conversas do Webchat"
            src={defaultSrc}
            width="100%"
            height="100%"
            onLoad={handleIframeLoad}
          />
        )}
      </ContainerIframe>
    </Container>
  );
};
